import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mutate-entity-modal-body" }
const _hoisted_2 = {
  key: 1,
  class: "loading apollo"
}

import { computed, PropType, reactive, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import enUK from "@/locales/invoicing/en-UK.json";
import FormItem from "@/components/form/FormItem.vue";
import Modal from "@/components/Modal.vue";
import BasicButton from "@/components/BasicButton.vue";
import { CREATE_INVOICE_FOR_EXPENSE } from "@/graphql/invoice/mutations";
import { useToast } from "vue-toastification";
import { useMutation, useQuery, useResult } from "@vue/apollo-composable";
import { logErrorMessages } from "@vue/apollo-util";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import dayjs from "dayjs";
import { DatePickerMarker } from "@vuepic/vue-datepicker";
import { GET_PROJECT_COMPANIES } from "@/graphql/invoice/queries";
import { DocumentNode } from "graphql";
type MessageSchema = typeof enUK;


export default /*@__PURE__*/_defineComponent({
  __name: 'AddInvoiceForExpense',
  props: {
  projectId: {
    type: String,
    required: true,
  },
  expenseId: {
    type: String,
    required: true,
  },
  refetchQueries: {
    type: Array as PropType<{ query: DocumentNode; variables?: object }[]>,
    required: false,
    default: () => [],
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n<[MessageSchema], "en-UK">({
  useScope: "global",
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

const toast = useToast();

const {
  result,
  loading: loadingCompanies,
  onError: onErrorCompanies,
} = useQuery(GET_PROJECT_COMPANIES, () => ({
  id: props.projectId,
}));

const companies = useResult(
  result,
  null,
  (result) => result?.project?.client?.companies,
);

onErrorCompanies((error) => {
  logErrorMessages(error);
  toast.error(t("errors.getCompanies"));
});

const companyId = ref("");
const dueDate = ref(dayjs().add(10, "day").format("YYYY-MM-DD"));

const variables = reactive({ companyId, dueDate });
const v$ = useVuelidate(
  {
    companyId: required,
    dueDate: required,
  },
  variables,
  {
    $autoDirty: true,
  },
);

const {
  mutate: createInvoice,
  onDone,
  onError,
  loading: createInvoiceLoading,
} = useMutation(CREATE_INVOICE_FOR_EXPENSE, () => ({
  variables: {
    companyId: companyId.value,
    projectId: props.projectId,
    expenseId: props.expenseId,
    dueDate: dueDate.value,
  },
  refetchQueries: props.refetchQueries,
  awaitRefetchQueries: true,
}));

onDone(async (result) => {
  console.log(JSON.stringify(result.data, null, 2));
  if (result.data?.createInvoiceForExpense?.status === "ok") {
    toast.success(t("success.createInvoice"));
    emit("close");
  } else {
    const errorResponse = result.data?.createInvoiceForExpense?.error;
    console.log(errorResponse);
    toast.error(t("errors.createInvoice", { message: errorResponse }));
  }
});

onError((error) => {
  logErrorMessages(error);
  toast.error(t("errors.createInvoice", { message: t("errors.internal") }));
});

const submitForm = async () => {
  const isFormCorrect = await v$.value.$validate();
  if (isFormCorrect) {
    return createInvoice();
  }
};

const closeModal = () => {
  emit("close");
};

const dateMarkers: DatePickerMarker[] = [
  {
    date: dayjs().add(10, "days").toDate(),
    type: "line",
    tooltip: [{ text: t("labels.defaultDueDate"), color: "blue" }],
  },
];

watch(
  // Set default company as first in the list
  companies,
  (newCompanies) => {
    if (Array.isArray(newCompanies) && newCompanies.length > 0) {
      companyId.value = newCompanies[0].id;
    }
  },
  { immediate: true },
);

const loading = computed(() => createInvoiceLoading.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, { onClose: closeModal }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("titles.edit")), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(companies))
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              id: `mutate-form-edit-delta`,
              onSubmit: _withModifiers(submitForm, ["prevent"])
            }, [
              _createVNode(FormItem, {
                input: companyId.value,
                "onUpdate:input": _cache[0] || (_cache[0] = ($event: any) => ((companyId).value = $event)),
                label: _unref(t)(`labels.companyId`),
                options: _unref(companies),
                name: "companyId",
                errors: _unref(v$).companyId.$errors
              }, null, 8, ["input", "label", "options", "errors"]),
              _createVNode(FormItem, {
                "date-markers": dateMarkers,
                input: dueDate.value,
                "onUpdate:input": _cache[1] || (_cache[1] = ($event: any) => ((dueDate).value = $event)),
                label: _unref(t)(`labels.dueDate`),
                name: "dueDate",
                "input-type": "date",
                errors: _unref(v$).dueDate.$errors
              }, null, 8, ["input", "label", "errors"])
            ], 32))
          : _createCommentVNode("", true),
        (loading.value || _unref(loadingCompanies))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)("loading")), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(BasicButton, {
        class: "mutate-button",
        type: "submit",
        color: "primary",
        form: `mutate-form-edit-delta`,
        disabled: loading.value,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(createInvoice)()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("buttons.createInvoice.now")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _renderSlot(_ctx.$slots, "footer")
    ]),
    _: 3
  }))
}
}

})